import { useContext } from "react";
import { AppContext } from "@context/AppContext";
import { Web3util } from "@util/web3util";
import PopupContractInformation from "./PopupContractInformation";
import Accordion from "@components/shared/Accordion/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCube, faPen, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const ContractPanel = ({
    activeTabLocalNetwork,
    contractName,
    contractAddress,
    setContractName,
    compilerVersion,
    setCompilerVersion,
    compilerOptimization,
    setCompilerOptimization,
    compilerRuns,
    setCompilerRuns,
    contractsInfoEditor,
    contractsNetworkEditor,
    contractsOriginalNetworkEditor,
}) => {
    // const { contractsInfo } = useContext(AppContext);
    // console.log("ContractPanel activeTabLocalNetwork", activeTabLocalNetwork);

    let networkItem1;
    let networkItem2;
    if (contractsOriginalNetworkEditor && contractsNetworkEditor && contractsOriginalNetworkEditor !== contractsNetworkEditor) {
        networkItem1 = (
            <p className="h-5">
                <span className="text-secondary">Original Network:</span>{" "}
                <span>
                    {contractsOriginalNetworkEditor && contractsOriginalNetworkEditor.name} ({contractsOriginalNetworkEditor && contractsOriginalNetworkEditor.id})
                </span>
            </p>
        );
        networkItem2 = (
            <p className="h-5">
                <span className="text-secondary">Current Network:</span>{" "}
                <span>
                    {contractsNetworkEditor && contractsNetworkEditor.name} ({contractsNetworkEditor && contractsNetworkEditor.id})
                </span>
            </p>
        );
    } else {
        networkItem1 = (
            <p className="h-5">
                <span className="text-secondary">Network:</span>{" "}
                <span>
                    {contractsOriginalNetworkEditor && contractsOriginalNetworkEditor.name} ({contractsOriginalNetworkEditor && contractsOriginalNetworkEditor.id})
                </span>
            </p>
        );
    }

    if (activeTabLocalNetwork === "network" && contractsInfoEditor) {
        return (
            <div className="py-1">
                <Accordion
                    id="ContractPanelAccordion"
                    name="ContractPanelAccordion"
                    title={"Details"}
                    items={[
                        networkItem1,
                        networkItem2,
                        !contractsInfoEditor.isProxy && (
                            <p className="h-5">
                                <span className="text-secondary">Address:</span> <span>{contractAddress ? Web3util.shortAddress(contractAddress, 10, 10) : "N/A"}</span>
                            </p>
                        ),
                        contractsInfoEditor.isProxy && contractsInfoEditor.proxyType === "transparent" && (
                            <p className="h-5">
                                <span className="text-secondary">Proxy Admin:</span>
                                <span className="pl-1" title={contractsInfoEditor.proxyAdminFromNetwork}>
                                    {contractAddress ? Web3util.shortAddress(contractsInfoEditor.proxyAdmin.addressFromNetwork, 8, 8) : "N/A"}
                                </span>
                                <FontAwesomeIcon
                                    id="ContractPanelProxyAdminAddressCopy"
                                    name="ContractPanelProxyAdminAddressCopy"
                                    icon={faCopy}
                                    className="text-secondary ml-2 cursor-pointer"
                                    onClick={() => {
                                        navigator.clipboard.writeText(contractsInfoEditor.proxyAdminFromNetwork);
                                    }}
                                />
                                <a href={contractsNetworkEditor.blockExplorerURL + "address/" + contractsInfoEditor.proxyAdminFromNetwork} target="_blank">
                                    <FontAwesomeIcon icon={faCube} className="text-secondary ml-2 cursor-pointer" />
                                </a>
                            </p>
                        ),
                        contractsInfoEditor.isProxy && (
                            <p className="h-5">
                                <span className="text-secondary">Proxy Address:</span>
                                <span className="pl-1" title={contractAddress}>
                                    {contractAddress ? Web3util.shortAddress(contractAddress, 8, 8) : "N/A"}
                                </span>
                                <FontAwesomeIcon
                                    id="ContractPanelProxyAddressCopy"
                                    name="ContractPanelProxyAddressCopy"
                                    icon={faCopy}
                                    className="text-secondary ml-2 cursor-pointer"
                                    data-info={JSON.stringify({ contractAddress: contractAddress })}
                                    //data-info={"TEST"}
                                    onClick={() => {
                                        navigator.clipboard.writeText(contractAddress);
                                    }}
                                />
                                <a
                                    href={contractsNetworkEditor.blockExplorerURL + "address/" + contractAddress}
                                    target="_blank"
                                    id="ContractPanelProxyAddressBlockExplorer"
                                    name="ContractPanelProxyAddressBlockExplorer">
                                    <FontAwesomeIcon icon={faCube} className="text-secondary ml-2 cursor-pointer" />
                                </a>
                            </p>
                        ),
                        contractsInfoEditor.isProxy && (
                            <p className="h-5">
                                <span className="text-secondary">Impl. Address:</span>
                                <span className="pl-1" title={contractsInfoEditor.implementation.address}>
                                    {contractAddress ? Web3util.shortAddress(contractsInfoEditor.implementation.address, 8, 8) : "N/A"}
                                </span>
                                {contractsInfoEditor.implementation &&
                                    contractsInfoEditor.implementation.address &&
                                    contractsInfoEditor.implementation.address.toLowerCase() !== contractsInfoEditor.implementation.addressFromNetwork.toLowerCase() && (
                                        <FontAwesomeIcon
                                            id="ContractPanelImplementationAddressWarning"
                                            name="ContractPanelImplementationAddressWarning"
                                            icon={faTriangleExclamation}
                                            className="text-secondary pl-2 cursor-pointer"
                                            title={
                                                "The registred implementation address in the Network " +
                                                contractsInfoEditor.implementationFromNetwork +
                                                " is different from the Block Explorer. Submit a new contract verification of the new implementation contract in the Block Explorer. If you already did, wait at least 15 minutes and check it again."
                                            }
                                        />
                                    )}
                                <FontAwesomeIcon
                                    id="ContractPanelImplementationAddressCopy"
                                    name="ContractPanelImplementationAddressCopy"
                                    icon={faCopy}
                                    className="text-secondary ml-2 cursor-pointer"
                                    onClick={() => {
                                        navigator.clipboard.writeText(contractsInfoEditor.implementation.address);
                                    }}
                                />
                                <a
                                    href={contractsNetworkEditor.blockExplorerURL + "address/" + contractsInfoEditor.implementation.address}
                                    target="_blank"
                                    id="ContractPanelImplementationAddressBlockExplorer"
                                    name="ContractPanelImplementationAddressBlockExplorer">
                                    <FontAwesomeIcon icon={faCube} className="text-secondary ml-2 cursor-pointer" />
                                </a>
                            </p>
                        ),
                        contractsInfoEditor.isProxy && (
                            <p className="h-5">
                                <span className="text-secondary">Proxy Type:</span>
                                <span className="pl-1">{contractsInfoEditor.proxyType}</span>
                            </p>
                        ),
                        <p className="h-5">
                            <span className="text-secondary">Name:</span> <span>{contractsInfoEditor.ContractName}</span>
                        </p>,
                        <p className="h-5">
                            <span className="text-secondary">EVMVersion Version:</span> <span>{contractsInfoEditor.EVMVersion}</span>
                        </p>,
                        <p className="h-5">
                            <span className="text-secondary">Compiler Version:</span> <span>{contractsInfoEditor.CompilerVersion}</span>
                        </p>,
                        <p className="h-5">
                            <span className="text-secondary">Optimization Enabled: </span>
                            <span>{contractsInfoEditor.OptimizationUsed === "0" ? "No" : "Yes (" + contractsInfoEditor.Runs + " Runs)"}</span>
                        </p>,
                        <p className="h-5">
                            <span className="text-secondary">License Type:</span>
                            <a id="ContractPanelLicenseLink" name="ContractPanelLicenseLink" href="https://opensource.org/licenses/" target="_blank">
                                <span className="pl-1">{contractsInfoEditor.licenseType !== "" ? contractsInfoEditor.licenseType : "N/A"}</span>
                            </a>
                        </p>,
                        // <div className="flex justify-center pt-4">
                        //     <label
                        //         htmlFor="popupContractInformation"
                        //         className="btn-default cursor-pointer"
                        //         onClick={() => {
                        //             console.log("popupContractInformation");
                        //         }}>
                        //         Update Info
                        //         <FontAwesomeIcon icon={faPen} className="pl-3" />
                        //     </label>
                        // </div>,
                        <PopupContractInformation
                            contractName={contractName}
                            setContractName={setContractName}
                            compilerVersion={compilerVersion}
                            setCompilerVersion={setCompilerVersion}
                            compilerOptimization={compilerOptimization}
                            setCompilerOptimization={setCompilerOptimization}
                            compilerRuns={compilerRuns}
                            setCompilerRuns={setCompilerRuns}
                        />,
                    ]}
                />
                {/* <p className="px-2 text-white font-semibold text-md">Contract Details</p>
                <div className="items-center px-2 mt-1 text-light font-normal">
                    <p className="h-6">
                        <span className="text-secondary">Address:</span> <span>{contractAddress ? Web3util.shortAddress(contractAddress, 10, 10) : "N/A"}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Name:</span> <span>{contractsInfoEditor.ContractName}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">EVMVersion Version:</span> <span>{contractsInfoEditor.EVMVersion}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Compiler Version:</span> <span>{contractsInfoEditor.CompilerVersion}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Optimization Enabled: </span>
                        <span>
                            {contractsInfoEditor.OptimizationUsed === "0" ? "No" : "Yes"} {contractsInfoEditor.OptimizationUsed === "1" && contractsInfoEditor.Runs}
                        </span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">License Type:</span> <span>{contractsInfoEditor.LicenseType !== "" ? contractsInfoEditor.LicenseType : "N/A"}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Implementation:</span> <span>{contractsInfoEditor.Implementation !== "" ? contractsInfoEditor.Implementation : "N/A"}</span>
                    </p>
                </div> */}
            </div>
        );
    } else if (activeTabLocalNetwork === "local") {
        return (
            <div className="py-2">
                <p className="px-2 text-white font-semibold text-md">Details</p>

                <div className="items-center px-2 mt-1 text-light font-normal">
                    <p className="h-6">
                        <span className="text-secondary">Contract Name:</span> <span>{contractName ?? "(auto)"}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">EVMVersion Version:</span> <span>Auto</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Compiler Version:</span> <span>{compilerVersion ?? "(latest)"}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Optimization Enabled: </span>
                        <span>{compilerOptimization ? "Yes" : "No"}</span>
                    </p>
                    <p className="h-6">
                        <span className="text-secondary">Optimization Runs:</span> <span>{compilerRuns}</span>
                    </p>
                    {/* <p>
                        <span className="text-secondary">License Type:</span> <span>N/A</span>
                    </p>
                    <p>
                        <span className="text-secondary">Implementation:</span> <span>N/A</span>
                    </p> */}
                </div>
                <div className="flex justify-center pt-4">
                    <label
                        htmlFor="popupContractInformation"
                        className="btn-default cursor-pointer"
                        onClick={() => {
                            console.log("popupContractInformation");
                        }}>
                        Update Info
                    </label>
                </div>
                <PopupContractInformation
                    contractName={contractName}
                    setContractName={setContractName}
                    compilerVersion={compilerVersion}
                    setCompilerVersion={setCompilerVersion}
                    compilerOptimization={compilerOptimization}
                    setCompilerOptimization={setCompilerOptimization}
                    compilerRuns={compilerRuns}
                    setCompilerRuns={setCompilerRuns}
                />
            </div>
        );
    }
};

export default ContractPanel;
